// extracted by mini-css-extract-plugin
module.exports = {"root":"AgreementModal_root__2u1MK","additionalInfo":"AgreementModal_additionalInfo__1VvI5"};